import { create } from "zustand";

import { TSelectPopupOption } from "components/SelectPopup";

type TIndeedCategoryStore = {
  indeedCategories?: TSelectPopupOption[];
  loadingIndeedCategory: boolean;
  onSetIndeedCategory: (indeedCategories: TSelectPopupOption[]) => void;
  onSetLoadingIndeedCategory: (loadingIndeedCategory: boolean) => void;
};

export const useIndeedCategoryStore = create<TIndeedCategoryStore>((set) => ({
  indeedCategories: undefined,
  loadingIndeedCategory: false,
  onSetIndeedCategory: (indeedCategories) => {
    set((state) => {
      return {
        ...state,
        indeedCategories: [
          ...(state?.indeedCategories ? state.indeedCategories : []),
          ...indeedCategories,
        ],
      };
    });

    set({ indeedCategories });
  },
  onSetLoadingIndeedCategory: (loadingIndeedCategory) => {
    set({ loadingIndeedCategory });
  },
}));
